import { getAvailableProgramMonitoringPeriods } from './getProgramMonitoringPeriods'
import { getSelectedPaddocks, getSelectedRodeoPaddocks } from './getSelectedPaddocks'
import { getMonitoringEvents } from './getMonitoringEvents'
import { getSamplingAreas } from './getSamplingAreas'
import { getMonitoringSites } from './getMonitoringSites'

export const optionGetters = {
  getSelectedPaddocks,
  getSelectedRodeoPaddocks,
  getAvailableProgramMonitoringPeriods,
  getMonitoringEvents,
  getSamplingAreas,
  getMonitoringSites,
}
